module.exports = __webpack_public_path__ + "img/detail5.10a584fc.jpg";